"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.source = exports.collect = void 0;
var _excluded = ["insert"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var editorId = 'editor-content-body';
var position = 0;
var source = {
  beginDrag: function beginDrag(_ref) {
    var insert = _ref.insert,
        props = _objectWithoutProperties(_ref, _excluded);

    var el = document.getElementById(editorId);
    position = el.scrollTop;
    props.layoutMode();
    setTimeout(function () {
      var el = document.getElementById(editorId);
      el.scrollTop = position;
    }, 200);
    return _objectSpread({
      node: insert,
      rawNode: function rawNode() {
        return insert;
      }
    }, props);
  },
  endDrag: function endDrag(props, monitor) {
    var item = monitor.getItem();

    if (monitor.didDrop()) {
      setTimeout(function () {
        item.insertMode();
      }, 10);
      setTimeout(function () {
        var el = document.getElementById(editorId);
        el.scrollTop = position;
      }, 200); // If the item drop occurred deeper down the tree, don't do anything

      return;
    }

    item.clearHover();
    setTimeout(function () {
      item.insertMode();
    }, 100);
  }
};
exports.source = source;

var collect = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview()
  };
};

exports.collect = collect;